/*****************************************************************************

 //ND_CMD                        //일반 함수
 * ndMonitorDevice               * ndAliveCheck
 * ndMonitorStop                 * ndGetLastErrMsg
 * ndChangeMonitorFilter         * ndChange2Msg    //구현x
 * ndSetAgentState               * ndMakeUUI
 * ndSetDoNotDisturb
 * ndSetForwarding
 * ndSetMsgWaitingInd
 * ndSetSpeakerMute              //ND_PRI
 * ndAnswerCall                  * ndGetAGTList, ndGetAGTList2
 * ndMakeCall                    * ndGetICDList
 * ndCallCompletion              * ndCallBack
 * ndClearCall                   * ndChangeFlag
 * ndClearConnection             * ndConnectEXE
 * ndHoldCall                    * ndGetGroupAgentList
 * ndRetrieveCall                * ndGetICDQueCnt
 * ndConsultationCall            * ndGetICDAgtCnt
 * ndConsultationCallExt         * ndLinkCheck
 * ndAlternateCall               * ndPriServiceStatus
 * ndConferenceCall              * ndPrivateData
 * ndDeflectCall                 * ndSavePdsCallResult
 * ndGroupPickupCall             * ndSetWorkMode
 * ndPickupCall                  * ndGetCenterStatus
 * ndReconnectCall                * ndGetAgentStatus
 * ndSingleStepTransferCall        * ndGetICDStatus, ndGetICDStatus2
 * ndTransferCall                * ndGetAGTState
 * ndQueryAgentState
 * ndQueryDeviceInfo
 * ndQueryDoNotDisturb
 * ndQueryForwarding
 * ndQueryLastNumber
 * ndQueryMsgWaitingInd
 * ndChatDisconnect
 * ndEscapeService
 * ndSendDTMF
 * ndSendMessage
 * ndOpenServer
 * ndCloseServer

 *****************************************************************************/

import ndProtocol from '@/util/call/neoWebRTC/neoWebRtcAPI/ndProtocol';
import apiFunction from '@/util/call/neoWebRTC/neoWebRtcAPI/apiFunction';
import apiEvent from '@/util/call/apiEvent';
import logReport from '@/util/logReport';
import ndDefs from '@/util/call/neoWebRTC/neoWebRtcAPI/ndDefs';
import callDefs from '@/util/call/neoWebRTC/neoWebRtcAPI/cstaDefs';
import ndCommon from '@/util/call/neoWebRTC/neoWebRtcAPI/ndCommon';
import { store } from '@/store/store';
import eventBus from '@/EventBus';
import Helpers from '@/util/helpers';
import ticketEvent from '@/store/modules/call/ticketEvent';

export default {
  ndMonitorDevice,
  ndMonitorStop,
  ndSetAgentState,
  ndAnswerCall,
  ndMakeCall,
  // ndCallCompletion,
  // ndClearCall,
  ndClearConnection,
  ndHoldCall,
  ndRetrieveCall,
  ndConsultationCall,
  ndConsultationCallExt,
  ndAlternateCall,
  ndConferenceCall,
  ndDeflectCall,
  ndGroupPickupCall,
  ndPickupCall,
  ndReconnectCall,
  ndSingleStepTransferCall,
  ndTransferCall,
  ndQueryAgentState,
  ndQueryDeviceInfo,
  ndQueryDoNotDisturb,
  ndQueryForwarding,
  ndQueryLastNumber,
  ndQueryMsgWaitingInd,
  ndChatDisconnect,
  ndEscapeService,
  ndSendDTMF,
  ndSendMessage,
  ndAliveCheck,
  ndGetLastErrMsg,
  ndChange2Msg,
  ndMakeUUI,
  ndGetAgentStatus,
  ndGetAGTList,
  ndGetAGTList2,
  ndGetICDList,
  ndCallBack,
  ndChangeFlag,
  ndConnectEXE,
  ndGetICDQueCnt,
  ndGetICDAgtCnt,
  ndLinkCheck,
  ndPriServiceStatus,
  ndPrivateData,
  ndSavePdsCallResult,
  ndSetWorkMode,
  ndGetCenterStatus,
  ndSaveRecPrivateKey,
  ndSaveRecCallInfo,
  ndGetGroupAgentList,
  // ndGetAgentStatus, unused
  ndGetICDStatus,
  ndGetICDStatus2,
  ndGetAGTState,
  eventTimer,
  EventProc,
  setCallInfo,
  initCallID,
  initIsLogin,
  oneInitCallID
};

var emptyCode = String.fromCharCode(0);
var gpDNHead = 0;
var gpDNTail = 0;

var agtState = 0; // 0:로그인,세부상태 1:로그아웃 2:대기 3:후처리

let callInfo = [new STCallInfo(), new STCallInfo()];

var isLogin = 0; // 0:로그아웃 1:로그인 -> 상태 flag 값

/*****************************************************************************
 * FUNCTON NAME : NDPacketConcate()
 * DESCRIPTION  : 전문 헤더를 구성
 * INPUT        :
 * OUTPUT       :
 *****************************************************************************/
function NDPacketConcate(target, command, Size) {
  var length;

  length = Size + ndProtocol.ND_PKT_SIZE_LENGTH + ndProtocol.ND_PKT_SIZE_COMMAND;

  length = apiFunction.fnLPad(length, 5, '0');
  command = apiFunction.fnLPad(command, 4, '0');

  target += length + command;

  return target;
}

/*****************************************************************************
 * FUNCTON NAME : ndMonitorDevice()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndMonitorDevice(dn, Call, Feature, Agent, Maintenance, Private, PrivateData) {
  // w2api_tel_number = dn
  var CmdSize;
  var packet = '';
  var MonitorDevice = new ndDefs.NDMonitorDevice_C();

  MonitorDevice.dn = dn;
  MonitorDevice.monitorFilter.call = Call;
  MonitorDevice.monitorFilter.feature = Feature;
  MonitorDevice.monitorFilter.agent = Agent;
  MonitorDevice.monitorFilter.maintenance = Maintenance;
  MonitorDevice.monitorFilter.privateFilter = Private;
  MonitorDevice.pData = PrivateData;

  CmdSize = 72;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_MONITOR_DEVICE, CmdSize)) === '') {
    // NDWriteLog(LEVEL3,gLogLevel,"","NDPacketConcate error");
    console.log('NDPacketConcate error');
    return false;
  }

  var array = new ArrayBuffer(81);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, MonitorDevice.dn, 9);
  apiFunction.inputNumCode(buffer, MonitorDevice.monitorFilter.call, 29);
  apiFunction.inputNumCode(buffer, MonitorDevice.monitorFilter.feature, 31);
  apiFunction.inputNumCode(buffer, MonitorDevice.monitorFilter.agent, 32);
  apiFunction.inputNumCode(buffer, MonitorDevice.monitorFilter.maintenance, 33);
  apiFunction.inputNumCode(buffer, MonitorDevice.monitorFilter.privateFilter, 37);
  apiFunction.inputStrCode(buffer, MonitorDevice.pData, 41);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  // NDWriteLog(LEVEL5,gLogLevel,"","SendData[%s]", packet);

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndMonitorStop()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /******************************************************************************/
function ndMonitorStop() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var MonitorStop = new ndDefs.NDMonitorStop_C();

  MonitorStop.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_MONITOR_ENDED, CmdSize)) === '') {
    console.log('NDPacketConcate error');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, MonitorStop.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndSetAgentState()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndSetAgentState(AgtMode, AgtID, AgtGrp, AgtPass, SubStatus) {
  if (AgtMode === callDefs.AgentMode.AM_LOG_IN && ndCommon.IS_CHANGE_STATUS) {
    // 로그인시 상태 변경 중에 들어오는 경우 대비 로직
    ndCommon.IS_CHANGE_STATUS = false;
  } else if (AgtMode === callDefs.AgentMode.AM_WORK_NOT_READY) {
    // 후처리 시도는 무조건 통과
    ndCommon.IS_CHANGE_STATUS = false;
  }
  if (ndCommon.IS_CHANGE_STATUS) {
    setTimeout(
      (AgtMode, AgtID, AgtGrp, Agt0Pass, SubStatus) => {
        ndSetAgentState(AgtMode, AgtID, AgtGrp, AgtPass, SubStatus);
      },
      500,
      AgtMode,
      AgtID,
      AgtGrp,
      AgtPass,
      SubStatus
    );
    return false;
  }
  ndCommon.IS_CHANGE_STATUS = true;
  // w2api_agent_id = AgtID
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var SetAgentState = ndDefs.NDSetAgentState_C;

  if (AgtMode < 0 || AgtMode > 5) {
    console.log('AgtMode is out of range!!');
    return false;
  }

  SetAgentState.dn = dn;
  SetAgentState.agentaMode = AgtMode;
  SetAgentState.agentID = AgtID;
  SetAgentState.agentGroup = AgtGrp;
  SetAgentState.agentPass = AgtPass;
  SetAgentState.subStatus = SubStatus;

  CmdSize = 60;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_SET_AGENT_STATE, CmdSize)) === '') {
    console.log('NDPacketConcat error!!');
    return false;
  }

  var array = new ArrayBuffer(69);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, SetAgentState.dn, 9);
  apiFunction.inputNumCode(buffer, SetAgentState.agentaMode, 29);
  apiFunction.inputStrCode(buffer, SetAgentState.agentID, 33);
  apiFunction.inputStrCode(buffer, SetAgentState.agentGroup, 46);
  apiFunction.inputStrCode(buffer, SetAgentState.agentPass, 56);
  apiFunction.inputStrCode(buffer, SetAgentState.subStatus, 66);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndAnswerCall()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndAnswerCall() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var AnswerCall = new ndDefs.NDAnswerCall_C();
  var callInfo = getCallInfo();
  var callIdx = findCallEvt(ndProtocol.ND_EVT_DELIVERED);

  if (callIdx === -1) {
    console.log('[w2api_answerCall] findCallEvt error');
    return false;
  }

  if (callInfo[callIdx].callId === 0) {
    console.log("[w2api_answerCall] Can't found Call Id");
    return false;
  }

  var AlertingCallID = callInfo[callIdx].callId;

  if (AlertingCallID <= 0) {
    console.log('AlertingCallID is empty!!');
    return false;
  }

  AnswerCall.dn = dn;
  AnswerCall.alertingCall.callID = AlertingCallID;
  AnswerCall.alertingCall.deviceID = dn;
  AnswerCall.alertingCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 92;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_ANSWER_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(101);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, AnswerCall.dn, 9);
  apiFunction.inputNumCode(buffer, AnswerCall.alertingCall.callID, 29);
  apiFunction.inputStrCode(buffer, AnswerCall.alertingCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, AnswerCall.alertingCall.devIDType, 97);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }
  // NDWriteLog(LEVEL5,gLogLevel,"","SendData[%s]", buffer);

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndMakeCall()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndMakeCall(Destination, UserInfo, InfoSize) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var MakeCall = new ndDefs.NDMakeCall_C();

  if (Destination.length <= 0) {
    console.log('Destination is empty!!');
    return false;
  }

  MakeCall.dn = dn;
  MakeCall.dest_dn = Destination;

  MakeCall.userInfo.type = ndCommon.ATTUUIProtocolType_t.UUI_IA5_ASCII;

  if (InfoSize > 256) {
    MakeCall.userInfo.data.value = UserInfo;
    MakeCall.userInfo.data.length = 256;
  } else {
    MakeCall.userInfo.data.value = UserInfo;
    MakeCall.userInfo.data.length = InfoSize;
  }

  CmdSize = 304;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_MAKE_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(313);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, MakeCall.dn, 9);
  apiFunction.inputStrCode(buffer, MakeCall.dest_dn, 29);
  apiFunction.inputNumCode(buffer, MakeCall.userInfo.type, 49);
  apiFunction.inputNumCode(buffer, MakeCall.userInfo.data.length, 53);
  apiFunction.inputStrCode(buffer, MakeCall.userInfo.data.value, 55);

  try {
    logReport.write(`[CHANGE-AGENT] ndMakeCall 통화중`); // 전화를 걸 때 네오메카에 보내는 이벤트에서 남기는 로그
    store.commit('changeCallAgentStatus', '통화중');
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndCallCompletion()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
// function ndCallCompletion (feature, CallID) {
//   var dn = store.getters.telNumber
//   var CmdSize
//   var packet = ''
//   var CallCompletion = new ndDefs.NDCallCompletion_C()
//
//   if (feature < 0 || feature > 2) {
//     console.log('feature is out of range!!')
//     return false
//   }
//
//   if (CallID <= 0) {
//     console.log('CallID is empty!!')
//     return false
//   }
//
//   CallCompletion.dn = dn
//   CallCompletion.feature = feature
//   CallCompletion.activeCall.callID = CallID
//   CallCompletion.activeCall.deviceID = dn
//   CallCompletion.activeCall.devIDType = STATIC_ID
//
//   CmdSize = 96
//
//   if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CALL_COMPLETION, CmdSize)) === '') {
//     console.log('NDPacketConcate error!!')
//     return false
//   }
//
//   var array = new ArrayBuffer(105)
//   var buffer = new Uint8Array(array)
//
//   apiFunction.inputStrCode(buffer, packet, 0)
//   apiFunction.inputStrCode(buffer, CallCompletion.dn, 9)
//   apiFunction.inputNumCode(buffer, CallCompletion.feature, 29)
//   apiFunction.inputNumCode(buffer, CallCompletion.activeCall.callID, 33)
//   apiFunction.inputStrCode(buffer, CallCompletion.activeCall.deviceID, 97)
//   apiFunction.inputNumCode(buffer, CallCompletion.activeCall.devIDType, 101)
//
//   try {
//     store.dispatch('sendMessageToCallSocket', buffer)
//   } catch (exception) {
//     console.log('send error : ' + exception)
//     return false
//   }
//
//   return true
// }

/*****************************************************************************
 * FUNCTON NAME : ndClearCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
// function ndClearCall (ActiveCallID) {
//   var dn = store.getters.telNumber
//   var CmdSize
//   var packet = ''
//   var ClearCall = new ndDefs.NDClearCall_C()
//
//   if (ActiveCallID <= 0) {
//     console.log('ActiveCallID is empty!!')
//     return false
//   }
//
//   ClearCall.dn = dn
//   ClearCall.activeCall.callID = ActiveCallID
//   ClearCall.activeCall.deviceID = dn
//   ClearCall.activeCall.devIDType = STATIC_ID
//
//   CmdSize = 92
//
//   if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CLEAR_CALL, CmdSize)) === '') {
//     console.log('NDPacketConcate error!!')
//     return false
//   }
//
//   var array = new ArrayBuffer(101)
//   var buffer = new Uint8Array(array)
//
//   apiFunction.inputStrCode(buffer, packet, 0)
//   apiFunction.inputStrCode(buffer, ClearCall.dn, 9)
//   apiFunction.inputNumCode(buffer, ClearCall.activeCall.callID, 29)
//   apiFunction.inputStrCode(buffer, ClearCall.activeCall.deviceID, 33)
//   apiFunction.inputNumCode(buffer, ClearCall.activeCall.devIDType, 97)
//
//   try {
//     store.dispatch('sendMessageToCallSocket', buffer)
//   } catch (exception) {
//     console.log('send error : ' + exception)
//     return false
//   }
//
//   return true
// }

/*****************************************************************************
  * FUNCTON NAME : ndClearConnection()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndClearConnection() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var ClearConnection = new ndDefs.NDClearConnection_C();

  var checkFlag = 0;
  var callInfo = getCallInfo();
  var callIdx = findCallEvt(ndProtocol.ND_EVT_FAILED);

  if (callIdx !== -1) {
    if (callInfo[callIdx].callId !== 0) {
      checkFlag = 1;
    }
  }

  if (checkFlag !== 1) {
    callIdx = findCallEvt(ndProtocol.ND_EVT_SERVICE_INITIATED);
    if (callIdx !== -1) {
      if (callInfo[callIdx].callId !== 0) {
        checkFlag = 1;
      }
    }
  }

  if (checkFlag !== 1) {
    callIdx = findCallEvt(ndProtocol.ND_EVT_ORIGINATED);
    if (callIdx !== -1) {
      if (callInfo[callIdx].callId !== 0) {
        checkFlag = 1;
      }
    }
  }

  if (checkFlag !== 1) {
    callIdx = findCallEvt(ndProtocol.ND_EVT_DELIVERED);
    if (callIdx !== -1) {
      if (callInfo[callIdx].callId !== 0) {
        checkFlag = 1;
      }
    }
  }

  if (checkFlag !== 1) {
    callIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);
    if (callIdx !== -1) {
      if (callInfo[callIdx].callId !== 0) {
        checkFlag = 1;
      }
    }
  }

  if (checkFlag !== 1) {
    callIdx = findCallEvt(ndProtocol.ND_EVT_CONFERENCED);
    if (callIdx !== -1) {
      if (callInfo[callIdx].callId !== 0) {
        checkFlag = 1;
      }
    }
  }

  if (checkFlag !== 1) {
    console.log("Can't find ndClearConnection Call Id");
    return false;
  }

  var ActiveCallID = callInfo[callIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  ClearConnection.dn = dn; // 20
  ClearConnection.activeCall.callID = ActiveCallID;
  ClearConnection.activeCall.deviceID = dn;
  ClearConnection.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 92;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CLEAR_CONNECTION, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(101);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ClearConnection.dn, 9);
  apiFunction.inputNumCode(buffer, ClearConnection.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, ClearConnection.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, ClearConnection.activeCall.devIDType, 97);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndHoldCall()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndHoldCall() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var HoldCall = new ndDefs.NDHoldCall_C();

  var callInfo = getCallInfo();
  var callIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);

  if (callIdx === -1) {
    console.log('[w2api_holdCall] findCallEvt error');
    return false;
  }

  if (callInfo[callIdx].callId === 0) {
    console.log("[w2api_holdCall] Can't found Call Id");
    return false;
  }

  var ActiveCallID = callInfo[callIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  HoldCall.dn = dn;
  HoldCall.activeCall.callID = ActiveCallID;
  HoldCall.activeCall.deviceID = dn;
  HoldCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 92;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_HOLD_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(101);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, HoldCall.dn, 9);
  apiFunction.inputNumCode(buffer, HoldCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, HoldCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, HoldCall.activeCall.devIDType, 97);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndRetrieveCall()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndRetrieveCall() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var RetrieveCall = new ndDefs.NDRetrieveCall_C();
  var callInfo = getCallInfo();
  var callIdx = findCallEvt(ndProtocol.ND_EVT_HELD);

  if (callIdx === -1) {
    console.log('[w2api_retrieveCall] findCallEvt error');
    return false;
  }

  if (callInfo[callIdx].callId === 0) {
    console.log("[w2api_retrieveCall] Can't found Call Id");
    return false;
  }

  if (callInfo[callIdx].holdingdn !== store.getters.telNumber) {
    console.log("[w2api_retrieveCall] Can't retreive held number");
    return false;
  }

  var HeldCallID = callInfo[callIdx].callId;

  if (HeldCallID <= 0) {
    console.log('HeldCallID is empty!!');
    return false;
  }

  RetrieveCall.dn = dn;
  RetrieveCall.heldCall.callID = HeldCallID;
  RetrieveCall.heldCall.deviceID = dn;
  RetrieveCall.heldCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 92;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_RETRIEVE_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(101);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, RetrieveCall.dn, 9);
  apiFunction.inputNumCode(buffer, RetrieveCall.heldCall.callID, 29);
  apiFunction.inputStrCode(buffer, RetrieveCall.heldCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, RetrieveCall.heldCall.devIDType, 97);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndConsultationCall()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndConsultationCall(Destination, UserInfo, InfoSize) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var ConsultationCall = new ndDefs.NDConsultationCall_C();

  var callInfo = getCallInfo();
  var callIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);

  if (callIdx === -1) {
    console.log('[w2api_consultCall] findCallEvt error');
    return false;
  }

  if (callInfo[callIdx].callId === 0) {
    console.log("[w2api_consultCall] Can't found Call Id");
    return false;
  }

  var ActiveCallID = callInfo[callIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (Destination.length <= 0) {
    console.log('Destination is empty!!');
    return false;
  }

  ConsultationCall.dn = dn;
  ConsultationCall.activeCall.callID = ActiveCallID;
  ConsultationCall.activeCall.deviceID = dn;
  ConsultationCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;
  ConsultationCall.dest_dn = Destination;
  ConsultationCall.userInfo.type = ndCommon.ATTUUIProtocolType_t.UUI_IA5_ASCII;

  if (InfoSize > 256) {
    ConsultationCall.userInfo.data.value = UserInfo;
    ConsultationCall.userInfo.data.length = 256;
  } else {
    ConsultationCall.userInfo.data.value = UserInfo; // 2
    ConsultationCall.userInfo.data.length = InfoSize; // 257
  }

  CmdSize = 375;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CONSULTATION_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(384);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ConsultationCall.dn, 9);
  apiFunction.inputNumCode(buffer, ConsultationCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, ConsultationCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, ConsultationCall.activeCall.devIDType, 97);
  apiFunction.inputStrCode(buffer, ConsultationCall.dest_dn, 101);
  apiFunction.inputNumCode(buffer, ConsultationCall.userInfo.type, 121);
  apiFunction.inputNumCode(buffer, ConsultationCall.userInfo.data.length, 125);
  apiFunction.inputStrCode(buffer, ConsultationCall.userInfo.data.value, 127);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndConsultationCallExt()
 * DESCRIPTION  : 메르디안 교환기에서 사용
 *                Consult시 Transfer인지 Conference인지 구분하여 올린다.
 *                => Transfer:0, Conference:1
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndConsultationCallExt(Destination, UserInfo, InfoSize, ConsultType) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var ConsultationCall = new ndDefs.NDConsultationCall_C();

  var callInfo = getCallInfo();
  var callIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);

  if (callIdx === 0) {
    console.log("can't find ndConsultationCall Call Id" + dn);
    return false;
  }

  if (callInfo[callIdx].callId === 0) {
    console.log("can't find ndConsultationCall Call Id" + dn);
    return false;
  }

  if (callInfo[callIdx].callId <= 0) {
    console.log('', 'ActiveCallID is empty!!');
    return false;
  }

  var ActiveCallID = callInfo[callIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (Destination.length <= 0) {
    console.log('Destination is empty!!');
    return false;
  }

  ConsultationCall.dn = dn;
  ConsultationCall.activeCall.callID = ActiveCallID;
  ConsultationCall.activeCall.deviceID = dn;
  ConsultationCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;
  ConsultationCall.dest_dn = Destination;

  ConsultationCall.userInfo.type = ndCommon.ATTUUIProtocolType_t.UUI_IA5_ASCII;

  if (InfoSize > 256) {
    ConsultationCall.userInfo.data.value = UserInfo;
    ConsultationCall.userInfo.data.length = 256;
  } else {
    ConsultationCall.userInfo.data.value = UserInfo;
    ConsultationCall.userInfo.data.length = InfoSize;
  }
  // Consult Type을 설정한다.
  if (ConsultType === 0) {
    // 0
    ConsultationCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;
  } else {
    // 1
    ConsultationCall.activeCall.devIDType = callDefs.ConnectionID_Device.DYNAMIC_ID;
  }

  CmdSize = 375;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CONSULTATION_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(384);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ConsultationCall.dn, 9);
  apiFunction.inputNumCode(buffer, ConsultationCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, ConsultationCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, ConsultationCall.activeCall.devIDType, 97);
  apiFunction.inputStrCode(buffer, ConsultationCall.dest_dn, 101);
  apiFunction.inputNumCode(buffer, ConsultationCall.userInfo.type, 121);
  apiFunction.inputNumCode(buffer, ConsultationCall.userInfo.data.length, 125);
  apiFunction.inputStrCode(buffer, ConsultationCall.userInfo.data.value, 127);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndAlternateCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndAlternateCall(ActiveCallID, HeldCallID) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var AlternateCall = new ndDefs.NDAlternateCall_C();

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (HeldCallID <= 0) {
    console.log('HeldCallID is empty!!');
    return false;
  }

  AlternateCall.dn = dn;

  AlternateCall.activeCall.callID = ActiveCallID;
  AlternateCall.activeCall.deviceID = dn;
  AlternateCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  AlternateCall.heldCall.callID = HeldCallID;
  AlternateCall.heldCall.deviceID = dn;
  AlternateCall.heldCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 164;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_ALTERNATE_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(173);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, AlternateCall.dn, 9);
  apiFunction.inputNumCode(buffer, AlternateCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, AlternateCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, AlternateCall.activeCall.devIDType, 97);
  apiFunction.inputNumCode(buffer, AlternateCall.heldCall.callID, 101);
  apiFunction.inputStrCode(buffer, AlternateCall.heldCall.deviceID, 105);
  apiFunction.inputNumCode(buffer, AlternateCall.heldCall.devIDType, 169);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndConferenceCall()
  * DESCRIPTION  : CTI Server에 로그인을 한다.
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndConferenceCall() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var ConferenceCall = new ndDefs.NDConferenceCall_C();

  var callInfo = getCallInfo();
  var ActCallIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);
  var HeldCallIdx = findCallEvt(ndProtocol.ND_EVT_HELD);

  if (ActCallIdx === -1) {
    console.log('[w2api_conferenceCall] findCallEvt error');
    return false;
  }

  if (callInfo[ActCallIdx].callId === 0) {
    console.log("[w2api_conferenceCall] Can't found Call Id");
    return false;
  }

  if (HeldCallIdx === -1) {
    console.log('[w2api_conferenceCall] findCallEvt error');
    return false;
  }

  if (callInfo[HeldCallIdx].callId === 0) {
    console.log("[w2api_conferenceCall] Can't found Call Id");
    return false;
  }

  var HeldCallID = callInfo[HeldCallIdx].callId;
  var ActiveCallID = callInfo[ActCallIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (HeldCallID <= 0) {
    console.log('HeldCallID is empty!!');
    return false;
  }

  ConferenceCall.dn = dn;
  ConferenceCall.heldCall.callID = HeldCallID;
  ConferenceCall.heldCall.deviceID = dn;
  ConferenceCall.heldCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;
  ConferenceCall.activeCall.callID = ActiveCallID;
  ConferenceCall.activeCall.deviceID = dn;
  ConferenceCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 164;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CONFERENCE_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(173);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ConferenceCall.dn, 9);
  apiFunction.inputNumCode(buffer, ConferenceCall.heldCall.callID, 29);
  apiFunction.inputStrCode(buffer, ConferenceCall.heldCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, ConferenceCall.heldCall.devIDType, 97);
  apiFunction.inputNumCode(buffer, ConferenceCall.activeCall.callID, 101);
  apiFunction.inputStrCode(buffer, ConferenceCall.activeCall.deviceID, 105);
  apiFunction.inputNumCode(buffer, ConferenceCall.activeCall.devIDType, 169);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndDeflectCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndDeflectCall(DeflectCallID, Destination, UserInfo, InfoSize) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var DeflectCall = new ndDefs.NDDeflectCall_C();

  if (DeflectCallID <= 0) {
    console.log('DeflectCallID is empty!!');
    return false;
  }

  if (Destination.length <= 0) {
    console.log('Destination is empty!!');
    return false;
  }

  DeflectCall.dn = dn;

  DeflectCall.deflectCall.callID = DeflectCallID;
  DeflectCall.deflectCall.deviceID = dn;
  DeflectCall.deflectCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;
  DeflectCall.dest_dn = Destination;

  DeflectCall.userInfo.type = ndCommon.ATTUUIProtocolType_t.UUI_IA5_ASCII;

  if (InfoSize > 256) {
    DeflectCall.userInfo.data.value = UserInfo;
    DeflectCall.userInfo.data.length = 256;
  } else {
    DeflectCall.userInfo.data.value = UserInfo;
    DeflectCall.userInfo.data.length = InfoSize;
  }

  CmdSize = 375;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_DEFLECT_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(384);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, DeflectCall.dn, 9);
  apiFunction.inputNumCode(buffer, DeflectCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, DeflectCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, DeflectCall.activeCall.devIDType, 97);
  apiFunction.inputStrCode(buffer, DeflectCall.dest_dn, 101);
  apiFunction.inputNumCode(buffer, DeflectCall.userInfo.type, 121);
  apiFunction.inputNumCode(buffer, DeflectCall.userInfo.data.length, 125);
  apiFunction.inputStrCode(buffer, DeflectCall.userInfo.data.value, 127);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGroupPickupCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGroupPickupCall(Destination) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GroupPickupCall = new ndDefs.NDGroupPickupCall_C();

  GroupPickupCall.dn = dn;
  GroupPickupCall.dest_dn = dn;

  CmdSize = 40;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_GROUP_PICKUP_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(49);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GroupPickupCall.dn, 9);
  apiFunction.inputStrCode(buffer, GroupPickupCall.dest_dn, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  // NDWriteLog(LEVEL5,gLogLevel,"","SendData[%s]", buffer);

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndPickupCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndPickupCall(deflectCallID, Destination) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var PickupCall = new ndDefs.NDPickupCall_C();

  if (deflectCallID <= 0) {
    console.log('DeflectCallID is empty!!');
    return false;
  }

  if (Destination.length <= 0) {
    console.log('Destination is empty!!');
    return false;
  }

  PickupCall.dn = dn;

  PickupCall.deflectCall.callID = deflectCallID;
  PickupCall.deflectCall.deviceID = Destination;
  PickupCall.dest_dn = dn;

  CmdSize = 92;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_PICKUP_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(121);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, PickupCall.dn, 9);
  apiFunction.inputNumCode(buffer, PickupCall.deflectCall.callID, 29);
  apiFunction.inputStrCode(buffer, PickupCall.deflectCall.deviceID, 33);
  apiFunction.inputStrCode(buffer, PickupCall.dest_dn, 101);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndReconnectCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndReconnectCall() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var ReconnectCall = new ndDefs.NDReconnectCall_C();

  var callInfo = getCallInfo();
  var ActCallIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);
  var HeldCallIdx = findCallEvt(ndProtocol.ND_EVT_HELD);

  if (ActCallIdx === -1) {
    ActCallIdx = findCallEvt(ndProtocol.ND_EVT_DELIVERED);
    if (ActCallIdx === -1) {
      console.log('[w2api_ndReconnectCall] findCallEvt error');
      return false;
    }
  }

  if (callInfo[ActCallIdx].callId === 0) {
    console.log("[w2api_ndReconnectCall] Can't found Call Id");
    return false;
  }

  if (HeldCallIdx === -1) {
    console.log('[w2api_ndReconnectCall] findCallEvt error');
    return false;
  }

  if (callInfo[HeldCallIdx].callId === 0) {
    console.log("[w2api_ndReconnectCall] Can't found Call Id");
    return false;
  }

  var ActiveCallID = callInfo[ActCallIdx].callId;
  var HeldCallID = callInfo[HeldCallIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (HeldCallID <= 0) {
    console.log('HeldCallID is empty!!');
    return false;
  }

  ReconnectCall.dn = dn;
  ReconnectCall.activeCall.callID = ActiveCallID;
  ReconnectCall.activeCall.deviceID = dn;
  ReconnectCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  ReconnectCall.heldCall.callID = HeldCallID;
  ReconnectCall.heldCall.deviceID = dn;
  ReconnectCall.heldCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 164;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_RECONNECT_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(173);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ReconnectCall.dn, 9);
  apiFunction.inputNumCode(buffer, ReconnectCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, ReconnectCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, ReconnectCall.activeCall.devIDType, 97);
  apiFunction.inputNumCode(buffer, ReconnectCall.heldCall.callID, 101);
  apiFunction.inputStrCode(buffer, ReconnectCall.heldCall.deviceID, 105);
  apiFunction.inputNumCode(buffer, ReconnectCall.heldCall.devIDType, 169);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSingleStepTransferCall()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSingleStepTransferCall(ActiveCallID, Destination, UserInfo, InfoSize) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var SingleStepTransferCall = new ndDefs.NDSingleStepTransferCall_C();

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (Destination.length <= 0) {
    console.log('Destination is empty!!');
    return false;
  }

  SingleStepTransferCall.dn = dn;
  SingleStepTransferCall.activeCall.callID = ActiveCallID;
  SingleStepTransferCall.activeCall.deviceID = dn;
  SingleStepTransferCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;
  SingleStepTransferCall.dest_dn = Destination;

  SingleStepTransferCall.userInfo.type = ndCommon.ATTUUIProtocolType_t.UUI_IA5_ASCII;

  if (InfoSize < 256) {
    SingleStepTransferCall.userInfo.data.value = UserInfo;
    SingleStepTransferCall.userInfo.data.length = UserInfo.length;
  } else {
    SingleStepTransferCall.userInfo.data.value = UserInfo;
    SingleStepTransferCall.userInfo.data.length = 256;
  }

  CmdSize = 375;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_SINGLE_STEP_TRANSFER, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(384);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, SingleStepTransferCall.dn, 9);
  apiFunction.inputNumCode(buffer, SingleStepTransferCall.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, SingleStepTransferCall.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, SingleStepTransferCall.activeCall.devIDType, 97);
  apiFunction.inputStrCode(buffer, SingleStepTransferCall.dest_dn, 101);
  apiFunction.inputNumCode(buffer, SingleStepTransferCall.userInfo.type, 121);
  apiFunction.inputNumCode(buffer, SingleStepTransferCall.userInfo.data.length, 125);
  apiFunction.inputStrCode(buffer, SingleStepTransferCall.userInfo.data.value, 127);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndTransferCall()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndTransferCall() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var TransferCall = new ndDefs.NDTransferCall_C();

  var callInfo = getCallInfo();

  var ActCallIdx = findCallEvt(ndProtocol.ND_EVT_ESTABLISHED);
  var HeldCallIdx = findCallEvt(ndProtocol.ND_EVT_HELD);

  if (ActCallIdx === -1) {
    ActCallIdx = findCallEvt(ndProtocol.ND_EVT_DELIVERED);
    if (ActCallIdx === -1) {
      ActCallIdx = findCallEvt(ndProtocol.ND_EVT_ORIGINATED);
      if (ActCallIdx === -1) {
        ActCallIdx = findCallEvt(ndProtocol.ND_EVT_SERVICE_INITIATED);
        if (ActCallIdx === -1) {
          console.log('[w2api_transferCall] findCallEvt error');
          return false;
        }
      }
    }
  }

  if (callInfo[ActCallIdx].callId === 0) {
    console.log("[w2api_transferCall] Can't found Call Id");
    return false;
  }

  if (HeldCallIdx === -1) {
    console.log('[w2api_transferCall] findCallEvt error');
    return false;
  }

  if (callInfo[HeldCallIdx].callId === 0) {
    console.log("[w2api_transferCall] Can't found Call Id");
    return false;
  }

  var HeldCallID = callInfo[HeldCallIdx].callId;
  var ActiveCallID = callInfo[ActCallIdx].callId;

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  if (HeldCallID <= 0) {
    console.log('HeldCallID is empty!!');
    return false;
  }

  TransferCall.dn = dn;

  TransferCall.heldCall.callID = HeldCallID;
  TransferCall.heldCall.deviceID = dn;
  TransferCall.heldCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  TransferCall.activeCall.callID = ActiveCallID;
  TransferCall.activeCall.deviceID = dn;
  TransferCall.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 164;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_TRANSFER_CALL, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(173);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, TransferCall.dn, 9);
  apiFunction.inputNumCode(buffer, TransferCall.heldCall.callID, 29);
  apiFunction.inputStrCode(buffer, TransferCall.heldCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, TransferCall.heldCall.devIDType, 97);
  apiFunction.inputNumCode(buffer, TransferCall.activeCall.callID, 101);
  apiFunction.inputStrCode(buffer, TransferCall.activeCall.deviceID, 105);
  apiFunction.inputNumCode(buffer, TransferCall.activeCall.devIDType, 169);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
  * FUNCTON NAME : ndQueryAgentState()
  * DESCRIPTION  :
  * INPUT        :
  * OUTPUT       : ND_RC_SUCC : 성공
  *                ND_RC_FAIL : 실패
  /*****************************************************************************/
function ndQueryAgentState() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var QueryAgentState = new ndDefs.NDQueryAgentState_C();

  QueryAgentState.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_QUERY_AGENT_STATE, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, QueryAgentState.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndQueryDeviceInfo()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndQueryDeviceInfo() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var QueryDeviceInfo = new ndDefs.NDQueryDeviceInfo_C();

  QueryDeviceInfo.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_QUERY_DEVICE_INFO, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, QueryDeviceInfo.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndQueryDoNotDisturb()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndQueryDoNotDisturb() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var QueryDoNotDisturb = new ndDefs.NDQueryDoNotDisturb_C();

  QueryDoNotDisturb.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_QUERY_DND, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, QueryDoNotDisturb.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndQueryForwarding()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndQueryForwarding() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var QueryForwarding = new ndDefs.NDQueryForwarding_C();

  QueryForwarding.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_QUERY_FWD, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, QueryForwarding.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndQueryLastNumber()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndQueryLastNumber() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var QueryLastNumber = new ndDefs.NDQueryLastNumber_C();

  QueryLastNumber.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_QUERY_LAST_NUMBER, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, QueryLastNumber.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndQueryMsgWaitingInd()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndQueryMsgWaitingInd() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var QueryMsgWaitingInd = new ndDefs.NDQueryMsgWaitingInd_C();

  QueryMsgWaitingInd.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_QUERY_MWI, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, QueryMsgWaitingInd.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndChatDisconnect()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndChatDisconnect() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var ChatDisconnect = new ndDefs.NDChatDisconnect_C();

  ChatDisconnect.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_CHATDISCONNECT, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ChatDisconnect.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndEscapeService()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndEscapeService(Escape) {
  // var dn = store.getters.telNumber
  var CmdSize;
  var packet = '';
  var EscapeService = new ndDefs.NDEscapeService_C();

  EscapeService.Escape = Escape;

  CmdSize = 512;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_ESCAPE_SERVICE, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(521);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, EscapeService.Escape, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSendDTMF()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSendDTMF(ActiveCallID, DTMF) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var SendDTMF = new ndDefs.NDSendDTMF_C();

  if (ActiveCallID <= 0) {
    console.log('ActiveCallID is empty!!');
    return false;
  }

  SendDTMF.dn = dn;
  SendDTMF.DTMF = DTMF;

  SendDTMF.activeCall.callID = ActiveCallID;
  SendDTMF.activeCall.deviceID = dn;
  SendDTMF.activeCall.devIDType = callDefs.ConnectionID_Device.STATIC_ID;

  CmdSize = 112;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_SEND_DTMF, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(121);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, SendDTMF.dn, 9);
  apiFunction.inputNumCode(buffer, SendDTMF.activeCall.callID, 29);
  apiFunction.inputStrCode(buffer, SendDTMF.activeCall.deviceID, 33);
  apiFunction.inputNumCode(buffer, SendDTMF.activeCall.devIDType, 97);
  apiFunction.inputStrCode(buffer, SendDTMF.DTMF, 101);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSendMessage()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSendMessage(destId, idDiv, msg) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var SendMessage = new ndDefs.NDMessage_C();

  if (destId.length <= 0) {
    console.log('dest_id is empty!!');
    return false;
  }

  if (idDiv !== '1' && idDiv !== '2' && idDiv !== '3') {
    console.log('id_div value is out of range!!');
    return false;
  }

  SendMessage.dn = dn;
  SendMessage.dest_id = destId;
  SendMessage.id_div = idDiv;
  SendMessage.Msg = msg;

  CmdSize = 453;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD_MESSAGE, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(462);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, SendMessage.dn, 9);
  apiFunction.inputStrCode(buffer, SendMessage.dest_id, 29);
  apiFunction.inputStrCode(buffer, SendMessage.id_div, 49);
  apiFunction.inputStrCode(buffer, SendMessage.Msg, 50);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndAliveCheck()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndAliveCheck() {
  var CmdSize;
  var packet = '';

  CmdSize = 0;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_CMD, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(9);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetLastErrMsg()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ErrMsg
 *****************************************************************************/
function ndGetLastErrMsg(dn, ErrMsg) {
  var pDN = 0;

  if ((pDN = FindDN(dn)) === 0) {
    // NDWriteLog(LEVEL3,gLogLevel,"","FindDN error[%s]",dn);
    console.log('FindDN error');
    return false;
  }

  ErrMsg = pDN.ErrMsg;
  return ErrMsg;
}

/*****************************************************************************
 * FUNCTON NAME : ndChange2Msg()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ErrMsg
 *****************************************************************************/
function ndChange2Msg(pEvent, pMessage) {
  // pEvent.u.e

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndMakeUUI()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ErrMsg
 *****************************************************************************/
function ndMakeUUI(custGrade, custTel, Dnis, ServiceCode, icdGroup, routeType, routeAgent1, routeAgent2, custInfo, outputString) {
  var szUUI = ''; // [129]

  szUUI += custGrade;
  szUUI += routeType;
  szUUI = apiFunction.makeUUI(szUUI, routeAgent1, 12);
  szUUI = apiFunction.makeUUI(szUUI, routeAgent2, 12);
  szUUI = apiFunction.makeUUI(szUUI, icdGroup, 4);

  szUUI = apiFunction.makeUUI(szUUI, ServiceCode, 4);
  szUUI = apiFunction.makeUUI(szUUI, Dnis, 20);
  szUUI = apiFunction.makeUUI(szUUI, custTel, 20);
  szUUI = apiFunction.makeUUI(szUUI, custInfo, 50);

  // szUUI[sizeof(szUUI) - 1] = '\0';

  console.log(szUUI.toString());
}

/*****************************************************************************
 * FUNCTON NAME : ndGetAgentStatus()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetAgentStatus(AgtID, divi) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GetAGTStatus = new ndDefs.NDGetAGTStatus_C();

  GetAGTStatus.dn = dn;
  GetAGTStatus.dest_id = AgtID;

  CmdSize = 41;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_AGENT_STATUS, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(50);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetAGTStatus.dn, 9);
  apiFunction.inputNumCode(buffer, GetAGTStatus.dest_id, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetAGTList()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetAGTList(IcdNo) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GetAGTList = new ndDefs.NDGetAGTList_C();

  GetAGTList.dn = dn;
  GetAGTList.IcdNo = IcdNo;

  CmdSize = 40;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_AGENTLIST, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(49);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetAGTList.dn, 9);
  apiFunction.inputStrCode(buffer, GetAGTList.IcdNo, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  // NDWriteLog(LEVEL5,gLogLevel,"","SendData[%s]", buffer);

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetAGTList2()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetAGTList2(IcdNo) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GetAGTList = new ndDefs.NDGetAGTList_C();

  GetAGTList.dn = dn;
  GetAGTList.IcdNo = IcdNo;

  CmdSize = 40;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_AGENTLIST2, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(49);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetAGTList.dn, 9);
  apiFunction.inputStrCode(buffer, GetAGTList.IcdNo, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  // NDWriteLog(LEVEL5,gLogLevel,"","SendData[%s]", buffer);

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetICDList()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetICDList() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GetICDList = new ndDefs.NDGetICDList_C();

  GetICDList.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_ICDLIST, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetICDList.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndCallBack()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndCallBack(SvcCode, CustID, ReturnID, ICDNo, BzInzNo, Message) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var CallBack = new ndDefs.NDCallBack_C();

  CallBack.ThisDN = dn; // 5
  CallBack.SvcCode = SvcCode; // 5
  CallBack.CustID = CustID; // 21
  CallBack.CustTelNo = ReturnID; // 21
  CallBack.IcdNo = ICDNo; // 5
  CallBack.BzInzNo = BzInzNo; // 65
  CallBack.Msg = Message; // 65

  CmdSize = 187;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_CALLBACK, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(196);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, CallBack.ThisDN, 9);
  apiFunction.inputStrCode(buffer, CallBack.SvcCode, 14);
  apiFunction.inputStrCode(buffer, CallBack.CustID, 19);
  apiFunction.inputStrCode(buffer, CallBack.CustTelNo, 40);
  apiFunction.inputStrCode(buffer, CallBack.IcdNo, 61);
  apiFunction.inputStrCode(buffer, CallBack.BzInzNo, 66);
  apiFunction.inputStrCode(buffer, CallBack.Msg, 131);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndChangeFlag()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndChangeFlag(CampaignId, CustID, CallFlag) {
  var CmdSize;
  var packet = '';
  var ChangeFlag = new ndDefs.NDChangeFlag_C();

  ChangeFlag.CampaignId = CampaignId; // 16
  ChangeFlag.CustID = CustID; // 21
  // AgtID 13
  ChangeFlag.CallFlag = CallFlag; // 4

  CmdSize = 54;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_CHANGEFLAG, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(63);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ChangeFlag.CampaignId, 9);
  apiFunction.inputStrCode(buffer, ChangeFlag.CustID, 25);
  apiFunction.inputStrCode(buffer, ChangeFlag.CallFlag, 59);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndConnectEXE()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndConnectEXE(ProcName, index) {
  var CmdSize;
  var packet = '';
  var ConnectEXE = new ndDefs.NDConnectEXE_C();

  ConnectEXE.ProcName = ProcName;
  ConnectEXE.index = index.toString();

  CmdSize = 25;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_CONNECTEXE, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(34);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, ConnectEXE.ProcName, 9);
  apiFunction.inputStrCode(buffer, ConnectEXE.index, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetICDQueCnt()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetICDQueCnt(IcdNo) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  // TODO CHECK NDGetICDQueCnt_C
  var GetICDQueCnt = new ndDefs.NDGetICDQueCnt_C();

  GetICDQueCnt.dn = dn;
  GetICDQueCnt.IcdNo = IcdNo;

  CmdSize = 48;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_ICDQUECNT, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(57);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetICDQueCnt.dn, 9);
  apiFunction.inputStrCode(buffer, GetICDQueCnt.IcdNo, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  // NDWriteLog(LEVEL5,gLogLevel,"","SendData[%s]", buffer);

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetICDAgtCnt()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetICDAgtCnt(IcdNo) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GetICDAgtCnt = new ndDefs.NDGetIcdAgtCnt_C();

  GetICDAgtCnt.dn = dn;
  GetICDAgtCnt.IcdNo = IcdNo;

  CmdSize = 48;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_ICDAGTCNT, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(57);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetICDAgtCnt.dn, 9);
  apiFunction.inputStrCode(buffer, GetICDAgtCnt.IcdNo, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndLinckCheck()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndLinkCheck(ProcName, index, Status) {
  var CmdSize;
  var packet = '';
  var LinkCheck = new ndDefs.NDLinkCheck_C();

  LinkCheck.ProcName = ProcName;
  LinkCheck.index = index.toString();
  LinkCheck.Status = Status;

  CmdSize = 26;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_LINKCHECK, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(35);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, LinkCheck.ProcName, 9);
  apiFunction.inputStrCode(buffer, LinkCheck.index, 29);
  apiFunction.inputStrCode(buffer, LinkCheck.Status, 34);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndPriServiceStatus()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndPriServiceStatus(ServiceType, ServiceNm) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var IvrService = new ndDefs.NDIVRServiceStatus_C();

  IvrService.dn = dn; // 5
  IvrService.SType = ServiceType; // 20
  IvrService.SName = ServiceNm; // 128

  CmdSize = 153;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_IVR_STATUS, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(162);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, IvrService.dn, 9);
  apiFunction.inputStrCode(buffer, IvrService.SType, 14);
  apiFunction.inputStrCode(buffer, IvrService.SName, 34);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndPrivateData()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndPrivateData(Command, CmdSize, PrivateData) {
  // var CmdSize unused
  var packet = '';

  if ((packet = NDPacketConcate(packet, Command, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(CmdSize + 9);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, PrivateData, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSavePdsCallResult()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSavePdsCallResult(
  thisDn,
  agentId,
  WorkMode,
  custId,
  campId,
  jobId,
  segmentId,
  phoneType,
  talkTime,
  result1,
  result2,
  extInfo1,
  extInfo2,
  extInfo3,
  extInfo4,
  extInfo5
) {
  var CmdSize;
  var packet = '';
  var pdsSaveCallResult = new ndDefs.NDPdsSaveCallResult_C();

  if (agentId.length <= 0) {
    console.log('ndSaveRecPrivateKey AgentID is empty!!');
    return false;
  }

  pdsSaveCallResult.dn = thisDn; // 5
  pdsSaveCallResult.AgtID = agentId; // 13
  pdsSaveCallResult.WorkMode = WorkMode; // 6
  pdsSaveCallResult.custId = custId; // 21
  pdsSaveCallResult.campaingId = campId; // 16
  pdsSaveCallResult.jobId = jobId; // 11
  pdsSaveCallResult.segmentId = segmentId; // 11
  pdsSaveCallResult.phoneType = phoneType; // 6
  pdsSaveCallResult.talkTime = talkTime; // 6
  pdsSaveCallResult.result1 = result1; // 6
  pdsSaveCallResult.result2 = result2; // 6
  pdsSaveCallResult.extInfo1 = extInfo1; // 129
  pdsSaveCallResult.extInfo2 = extInfo2; // 129
  pdsSaveCallResult.extInfo3 = extInfo3; // 129
  pdsSaveCallResult.extInfo4 = extInfo4; // 129
  pdsSaveCallResult.extInfo5 = extInfo5; // 129

  CmdSize = 752;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PDS_SAVE_CALLRESULT, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(761);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.dn, 9);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.AgtID, 14);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.WorkMode, 27);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.custId, 33);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.campaingId, 54);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.jobId, 70);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.segmentId, 81);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.phoneType, 92);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.talkTime, 98);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.result1, 104);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.result2, 110);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.extInfo1, 116);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.extInfo2, 245);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.extInfo3, 374);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.extInfo4, 503);
  apiFunction.inputStrCode(buffer, pdsSaveCallResult.extInfo5, 632);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSetWorkMode()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSetWorkMode(agtId, workMode) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var SetWorkMode = new ndDefs.NDSetWorkMode_C();

  if (agtId.length <= 0) {
    console.log('ndSetWorkMode AgentID is empty!!');
    return false;
  }

  if (workMode[0] !== 'I' && workMode[0] !== 'O' && workMode[0] !== 'E' && workMode[0] !== 'B') {
    console.log("ndSetWorkMode Mode value is out of range!! 'I' or 'O' or 'E' or 'B'");
    return false;
  }

  SetWorkMode.dn = dn; // 5
  SetWorkMode.AgtID = agtId; // 13
  SetWorkMode.WorkMode = workMode; // 1

  CmdSize = 19;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_SET_WORK_MODE, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(28);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, SetWorkMode.dn, 9);
  apiFunction.inputStrCode(buffer, SetWorkMode.AgtID, 14);
  apiFunction.inputStrCode(buffer, SetWorkMode.WorkMode, 27);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetCenterStatus()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetCenterStatus() {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var GetCenterStatus = new ndDefs.NDGetCenterStatus_C();

  GetCenterStatus.dn = dn;

  CmdSize = 20;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_CENTER_STATUS, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(29);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetCenterStatus.dn, 9);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSaveRecPrivateKey()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSaveRecPrivateKey(thisDn, agentId, key) {
  var CmdSize;
  var packet = '';
  var recSaveKey = new ndDefs.NDRecordSaveKey_C();

  if (agentId.length <= 0) {
    console.log('ndSaveRecPrivateKey AgentID is empty!!');
    return false;
  }

  recSaveKey.dn = thisDn;
  recSaveKey.AgtID = agentId;
  recSaveKey.recKey = key;

  CmdSize = 147;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_REC_SAVE_KEY, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(156);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, recSaveKey.dn, 9);
  apiFunction.inputStrCode(buffer, recSaveKey.AgtID, 14);
  apiFunction.inputStrCode(buffer, recSaveKey.recKey, 27);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndSaveRecCallInfo()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndSaveRecCallInfo(thisDn, agentId, key, info1, info2, info3, info4, info5, info6, info7, info8, info9, info10) {
  // TODO: Add your dispatch handler code here

  var CmdSize;
  var packet = '';
  var recSaveCallInfo = new ndDefs.NDRecordSaveCallInfo_C();

  // var dn = store.getters.telNumber

  if (agentId.length <= 0) {
    console.log('ndSaveRecPrivateKey AgentID is empty!!');
    return false;
  }

  recSaveCallInfo.dn = thisDn;
  recSaveCallInfo.AgtID = agentId;
  recSaveCallInfo.recKey = key;
  recSaveCallInfo.extInfo1 = info1;
  recSaveCallInfo.extInfo2 = info2;
  recSaveCallInfo.extInfo3 = info3;
  recSaveCallInfo.extInfo4 = info4;
  recSaveCallInfo.extInfo5 = info5;
  recSaveCallInfo.extInfo6 = info6;
  recSaveCallInfo.extInfo7 = info7;
  recSaveCallInfo.extInfo8 = info8;
  recSaveCallInfo.extInfo9 = info9;
  recSaveCallInfo.extInfo10 = info10;

  CmdSize = 1436;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_REC_SAVE_CALLINFO, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(1445);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.dn, 9);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.AgtID, 14);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.recKey, 26);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo1, 155);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo2, 284);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo3, 413);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo4, 542);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo5, 671);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo6, 800);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo7, 929);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo8, 1058);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo9, 1187);
  apiFunction.inputStrCode(buffer, recSaveCallInfo.extInfo10, 1316);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetGroupAgentList()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetGroupAgentList(major, minor, icdNo, status, substatus) {
  var dn = store.getters.telNumber;
  var CmdSize;
  var packet = '';
  var agentList = new ndDefs.NDGetGroupAgentList_C();

  agentList.dn = dn; // 20
  agentList.major = major; // 6
  agentList.minor = minor; // 6

  /* ubase는 제거한다 */
  agentList.icdNo = icdNo; // 5
  agentList.status = status; // 1
  agentList.substatus = substatus; // 2

  CmdSize = 40;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_GROUP_AGENTLIST, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(49);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, agentList.dn, 9);
  apiFunction.inputStrCode(buffer, agentList.major, 29);
  apiFunction.inputStrCode(buffer, agentList.minor, 35);

  /* ubase는 제거한다 */
  apiFunction.inputStrCode(buffer, agentList.icdNo, 41);
  apiFunction.inputStrCode(buffer, agentList.status, 46);
  apiFunction.inputStrCode(buffer, agentList.substatus, 47);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetAgentStatus()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
// function ndGetAgentStatus (destId, Div) {
//   // TODO: Add your dispatch handler code here
//   var CmdSize
//   var packet = ''
//   var GetAGTStatus = new ndDefs.NDGetAGTStatus_C()
//
//   var dn = store.getters.telNumber
//
//   if (destId.length <= 0) {
//     console.log('dest_id is empty!!')
//     return false
//   }
//
//   if (Div !== '1' && Div !== '2' && Div !== '3') {
//     console.log('id_div value is out of range!!')
//     return false
//   }
//
//   GetAGTStatus.dn = dn
//   GetAGTStatus.dest_id = destId
//   GetAGTStatus.id_div = Div[0]
//
//   CmdSize = 41
//
//   if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_AGENT_STATUS, CmdSize)) === '') {
//     console.log('NDPacketConcate error!!')
//     return false
//   }
//
//   var array = new ArrayBuffer(50)
//   var buffer = new Uint8Array(array)
//
//   apiFunction.inputStrCode(buffer, packet, 0)
//   apiFunction.inputStrCode(buffer, GetAGTStatus.dn, 9)
//   apiFunction.inputStrCode(buffer, GetAGTStatus.dest_id, 29)
//   apiFunction.inputStrCode(buffer, GetAGTStatus.id_div, 49)
//
//   try {
//     store.dispatch('sendMessageToCallSocket', buffer)
//   } catch (exception) {
//     console.log('send error : ' + exception)
//     return false
//   }
//
//   return true
// }

/*****************************************************************************
 * FUNCTON NAME : ndGetICDStatus()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetICDStatus(IcdNo) {
  var CmdSize;
  var packet = '';
  var GetICDStatus = new ndDefs.NDICDStatus_C();

  var dn = store.getters.telNumber;

  GetICDStatus.dn = dn;
  GetICDStatus.ICDNo = IcdNo;

  CmdSize = 42;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_ICDSTATUS, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(51);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetICDStatus.dn, 9);
  apiFunction.inputStrCode(buffer, GetICDStatus.ICDNo, 30);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetICDStatus2()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetICDStatus2(IcdNo) {
  var CmdSize;
  var packet = '';
  var GetICDStatus = new ndDefs.NDICDStatus_C();

  var dn = store.getters.telNumber;

  GetICDStatus.dn = dn;
  GetICDStatus.ICDNo = IcdNo;

  CmdSize = 42;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_ICDSTATUS2, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(51);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetICDStatus.dn, 9);
  apiFunction.inputStrCode(buffer, GetICDStatus.ICDNo, 30);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

/*****************************************************************************
 * FUNCTON NAME : ndGetAGTState()
 * DESCRIPTION  :
 * INPUT        :
 * OUTPUT       : ND_RC_SUCC : 성공
 *                ND_RC_FAIL : 실패
 *****************************************************************************/
function ndGetAGTState(AgtID) {
  var CmdSize;
  var packet = '';
  var GetAGTState = new ndDefs.NDGetAGTState_C();
  var dn = store.getters.telNumber;

  CmdSize = 40;

  GetAGTState.dn = dn;
  GetAGTState.AgtID = AgtID;

  if ((packet = NDPacketConcate(packet, ndProtocol.ND_PRI_AGENTSTATE, CmdSize)) === '') {
    console.log('NDPacketConcate error!!');
    return false;
  }

  var array = new ArrayBuffer(49);
  var buffer = new Uint8Array(array);

  apiFunction.inputStrCode(buffer, packet, 0);
  apiFunction.inputStrCode(buffer, GetAGTState.dn, 9);
  apiFunction.inputStrCode(buffer, GetAGTState.AgtID, 29);

  try {
    store.dispatch('sendMessageToCallSocket', buffer);
  } catch (exception) {
    console.log('send error : ' + exception);
    return false;
  }

  return true;
}

// ADD 20210720 at apiEvent.js
/*****************************************************************************
 * FUNCTON NAME : w2api_event_timer()
 * DESCRIPTION  : Event를 수시로 확인하여 w2api_event_timer()를 호출
 * OUTPUT       :
 *****************************************************************************/
function eventTimer() {
  var tempPAPI = ndGetEvent();

  if (tempPAPI !== 0) {
    callProcess(tempPAPI);
    eventTimer();
  } else {
    if (store.getters.IS_CALL_CONNECTED) {
      setTimeout(() => {
        eventTimer();
      }, 100);
    }
  }
}

function STCallInfo() {
  this.callId = 0;
  this.evt = 0;
  this.redirection_dn = '';
  this.calling_dn = '';
  this.called_dn = '';
  this.userInfo = '';
  this.holdingdn = '';
  this.localconnstate = 0;
  this.eventcause = 0;
}

function ndGetEvent() {
  if (!(gpDNHead instanceof ndCommon.P_API)) {
    return 0;
  }

  var tempAPI;
  tempAPI = gpDNHead;

  if (gpDNHead === gpDNTail) {
    gpDNHead = 0;
    gpDNTail = 0;
  } else {
    gpDNHead = gpDNHead.next;
  }

  return tempAPI;
}

function EventProc(buffer8) {
  var pEvent;

  /* HEADER */
  var headLength = parseInt(String.fromCharCode.apply(null, buffer8.slice(0, 5)).replaceAll(emptyCode, ''));
  var Event = parseInt(String.fromCharCode.apply(null, buffer8.slice(5, 9)).replaceAll(emptyCode, ''));
  var buffer = buffer8.slice(9, headLength);
  switch (Event) {
    case ndProtocol.ND_EVT:
      pEvent.Event.event = Event;
      break;
    case ndProtocol.ND_EVT_LOGGED_ON:
      pEvent = EvtLoggedOn(buffer, Event);
      break;
    case ndProtocol.ND_EVT_LOGGED_OFF:
      pEvent = EvtLoggedOff(buffer, Event);
      break;
    case ndProtocol.ND_EVT_MONITOR_DEVICE:
      pEvent = EvtMonitorConf(buffer, Event);
      store.commit('changeIsTelIng', true);
      store.commit('changeIsValidTel', true);
      store.commit('LOGIN_CALL');
      store.commit('initDimmed');
      logReport.write(`[MONITOR-START]`);
      break;
    case ndProtocol.ND_EVT_CHG_MONITOR:
      pEvent = EvtChangeMonitorConf(buffer, Event);
      break;
    case ndProtocol.ND_EVT_MONITOR_ENDED:
      logReport.write(`[MONITOR-END]`);
      pEvent = EvtMonitorEnded(buffer, Event);
      if (Helpers.isStringValid(store.getters.loginId)) {
        store.commit('OPEN_CALL');
      }
      store.commit('CLOSE_CALL_SOCKET');
      break;
    case ndProtocol.ND_EVT_MESSAGE_WAITING:
      pEvent = EvtMessageWaiting(buffer, Event);
      break;
    case ndProtocol.ND_EVT_DO_NOT_DISTURB:
      pEvent = EvtDoNotDisturb(buffer, Event);
      break;
    case ndProtocol.ND_EVT_FORWARDING:
      pEvent = EvtForwarding(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUERY_MWI:
      pEvent = EvtQueryMWI(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUERY_DND:
      pEvent = EvtQueryDND(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUERY_FWD:
      pEvent = EvtQueryFWD(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUERY_AGENT_STATE:
      pEvent = EvtQueryAgentState(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUERY_LAST_NUMBER:
      pEvent = EvtQueryLastNumber(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUERY_DEVICE_INFO:
      pEvent = EvtQueryDeviceInfo(buffer, Event);
      break;
    case ndProtocol.ND_EVT_SERVICE_INITIATED:
      pEvent = EvtServiceInitiated(buffer, Event);
      break;
    case ndProtocol.ND_EVT_ORIGINATED:
      pEvent = EvtOriginated(buffer, Event);
      break;
    case ndProtocol.ND_EVT_DELIVERED:
      pEvent = EvtDelivered(buffer, Event);
      if (!store.getters.callInfo.recordNo) {
        store.commit('changeRecordNo', pEvent.Event.u.e.pData.concat('_', store.getters.telNumber));
      }
      break;
    case ndProtocol.ND_EVT_ESTABLISHED:
      pEvent = EvtEstablished(buffer, Event);
      break;
    case ndProtocol.ND_EVT_CALL_CLEARED:
      pEvent = EvtCallCleared(buffer, Event);
      break;
    case ndProtocol.ND_EVT_CONNECTION_CLEARED:
      pEvent = EvtConnectionCleared(buffer, Event);
      break;
    case ndProtocol.ND_EVT_HELD:
      pEvent = EvtHeld(buffer, Event);
      break;
    case ndProtocol.ND_EVT_RETRIEVED:
      pEvent = EvtRetrieved(buffer, Event);
      break;
    case ndProtocol.ND_EVT_TRANSFERRED:
      pEvent = EvtTransferred(buffer, Event);
      break;
    case ndProtocol.ND_EVT_CONFERENCED:
      pEvent = EvtConferenced(buffer, Event);
      break;
    case ndProtocol.ND_EVT_QUEUED:
      pEvent = EvtQueued(buffer, Event);
      break;
    case ndProtocol.ND_EVT_DIVERTED:
      pEvent = EvtDiverted(buffer, Event);
      break;
    case ndProtocol.ND_EVT_NETWORK_REACHED:
      pEvent = EvtNetworkReached(buffer, Event);
      break;
    case ndProtocol.ND_EVT_CALL_INFORMATION:
      pEvent = EvtCallInformation(buffer, Event);
      break;
    case ndProtocol.ND_EVT_BACK_IN_SERVICE:
      pEvent = EvtBackInService(buffer, Event);
      break;
    case ndProtocol.ND_EVT_OUT_OF_SERVICE:
      pEvent = EvtOutOfService(buffer, Event);
      break;
    case ndProtocol.ND_EVT_FAILED:
      pEvent = EvtFailed(buffer, Event);
      break;
    case ndProtocol.ND_EVT_SCREENPOP:
      pEvent = EvtScreenPop(buffer, Event);
      break;
    case ndProtocol.ND_EVT_CHATDISCONNECT:
      pEvent = EvtChatDisconnect(buffer, Event);
      break;
    case ndProtocol.ND_EVT_UNIVERSAL_FAILURE:
      pEvent = EvtUniversalFailure(buffer, Event);
      break;
    case ndProtocol.ND_CMD_MAKE_PREDICTIVE_CALL:
      pEvent = CmdMakePredictiveCall(buffer, Event);
      break;
    /*
     case ndProtocol.ND_EVT_CALLID_CHANGE:
       pEvent = EvtCallIDChange( buffer, Event, pEvent);
       break;
      */

    // EvtMessage 통일
    case ndProtocol.ND_PRI_ICDLIST:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_PRI_AGENTLIST:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_PRI_AGENTLIST2:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_PRI_AGENTSTATE:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_PRI_ICDSTATUS:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_PRI_ICDSTATUS2:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_PRI_GROUP_AGENT_LIST:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_EVT_MSGXFER:
      pEvent = EvtMessage(buffer, Event);
      break;
    case ndProtocol.ND_ERR_MONITOR_DEVICE:
      pEvent = EvtMessage(buffer, Event);
      if (pEvent.Event.u.m.Message.indexOf('Already monitoring device') > -1) {
        store.commit('changeIsTelIng', false);
        store.commit('initDimmed');
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: '<dl class="txt"><dt>이미 사용중인 내선번호입니다.<br/>내선번호 사용 유무를 확인 후 새로고침을 해주세요.</dd></dl>',
          getButtonEvent: () => {
            store.dispatch('logout').then((res) => {
              if (res) {
                window.location.href = '/member/login';
              }
            });
          },
          getBtnCount: 1
        });
      } else if (pEvent.Event.u.m.Message.indexOf('unregistered dn') > -1) {
        store.commit('changeIsValidTel', false);
        store.commit('initDimmed');
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML:
            '<dl class="txt"><dt>상담사의 내선번호가 시스템에 미등록된 내선번호입니다.<br/>관리자에게 확인 후 재로그인 해주세요.</dd></dl>',
          getBtnCount: 1
        });
      }
      break;

    case ndProtocol.ND_ERR_CHG_MONITOR_FILTER:
    case ndProtocol.ND_ERR_MONITOR_ENDED:
    case ndProtocol.ND_ERR_SET_AGENT_STATE:
    case ndProtocol.ND_ERR_SET_MWI:
    case ndProtocol.ND_ERR_SET_DND:
    case ndProtocol.ND_ERR_SET_FWD:
    case ndProtocol.ND_ERR_QUERY_MWI:
    case ndProtocol.ND_ERR_QUERY_DND:
    case ndProtocol.ND_ERR_QUERY_FWD:
    case ndProtocol.ND_ERR_QUERY_AGENT_STATE:
    case ndProtocol.ND_ERR_QUERY_LAST_NUMBER:
    case ndProtocol.ND_ERR_QUERY_DEVICE_INFO:
    case ndProtocol.ND_ERR_MAKE_CALL:
    case ndProtocol.ND_ERR_MAKE_PREDICTIVE_CALL:
    case ndProtocol.ND_ERR_ANSWER_CALL:
    case ndProtocol.ND_ERR_CALL_COMPLETION:
    case ndProtocol.ND_ERR_CLEAR_CALL:
    case ndProtocol.ND_ERR_CLEAR_CONNECTION:
    case ndProtocol.ND_ERR_HOLD_CALL:
    case ndProtocol.ND_ERR_RETRIEVE_CALL:
    case ndProtocol.ND_ERR_CONSULTATION_CALL:
    case ndProtocol.ND_ERR_RECONNECT_CALL:
    case ndProtocol.ND_ERR_ALTERNATE_CALL:
    case ndProtocol.ND_ERR_TRANSFER_CALL:
    case ndProtocol.ND_ERR_CONFERENCE_CALL:
    case ndProtocol.ND_ERR_DEFLECT_CALL:
    case ndProtocol.ND_ERR_SINGLE_SETP_TRANSFER:
    case ndProtocol.ND_ERR_PICKUP_CALL:
    case ndProtocol.ND_ERR_GROUP_PICKUP_CALL:
    case ndProtocol.ND_ERR_SEND_DTMF:
      // ((NDMessage_E *)buffer)->msgCode = 0;
      pEvent = EvtMessage(buffer, Event);
      if (pEvent.Event.u.m.Message) {
        eventBus.$emit('call-error', pEvent.Event.u.m.Message);
      }
      break;
    case ndProtocol.ND_EVT_MESSAGE:
      setTimeout(() => {
        const { IS_CALL_CONNECTED, enabledCallAgent } = store.getters;
        if (IS_CALL_CONNECTED && enabledCallAgent) {
          apiEvent.getSelfMonitor();
          apiEvent.getNeoRtcWaitingCount();
        }
      }, 5000);
      break;
    case ndProtocol.ND_EVT_DELIVERED_UEI:
      pEvent = EvtDeliveredUEI(buffer, Event);
      break;
    case ndProtocol.ND_EVT_CONFERENCED_IVR:
      pEvent = EvtConferencedIVR(buffer, Event);
      break;

    default:
      return;
  }

  if (!(gpDNHead instanceof ndCommon.P_API)) {
    gpDNHead = pEvent;
    gpDNTail = pEvent;
  } else {
    gpDNTail.next = pEvent;
    gpDNTail = pEvent;
  }

  if (headLength < buffer8.length) {
    apiEvent.EventProc(buffer8.slice(headLength));
  }
}

/*****************************************************************************
 * FUNCTON NAME : w2api_call_process()
 * DESCRIPTION  : CTI Server에서 수신한 이벤트 구조체 처리.
 * INPUT        : CTI Server에서 수신한 이벤트 구조체
 * OUTPUT       : P_API 구조체
 *****************************************************************************/
function callProcess(PAPI) {
  if (isLogin !== 1 && store.getters.callLoginId) {
    isLogin = 1;
    if (PAPI.Event.u.e.AGTstate === 0) {
      logReport.write(`[AGT-STATE]로그인 ${PAPI.Event.u.e.AGTstate}`);
      eventBus.$emit('call-data-update');
    }
  }
  if (PAPI.Event.event === ndProtocol.ND_EVT_QUERY_AGENT_STATE) {
    if (PAPI.Event.u.e.AGTstate === 0) {
      /* AG_NOT_READY */
      agtState = 0;
      isLogin = 1;
    } else if (PAPI.Event.u.e.AGTstate === 1) {
      /* 로그아웃 AG_NULL */
      agtState = 1;
      isLogin = 0;
      logReport.write(`[AGT-STATE]로그아웃 ${PAPI.Event.u.e.AGTstate}`);
      ndMonitorStop();
    } else if (PAPI.Event.u.e.AGTstate === 2) {
      /* 대기 AG_READY */
      agtState = 2;
      logReport.write(`[AGT-STATE]대기 ${PAPI.Event.u.e.AGTstate}`);
    } else if (PAPI.Event.u.e.AGTstate === 3) {
      /* 후처리 AG_WORK_NOT_READY */
      agtState = 3;
      logReport.write(`[AGT-STATE]후처리 ${PAPI.Event.u.e.AGTstate}`);
    } else {
      logReport.write(`[AGT-STATE] ${PAPI.Event.u.e.AGTstate}`);
    }
    apiEvent.getNeoRtcAgentWorkData();
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_NETWORK_REACHED) {
    let callIdx = findCallID(PAPI.Event.u.e.CallID);
    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
      callInfo[callIdx].evt = ndProtocol.ND_EVT_NETWORK_REACHED;
      callInfo[callIdx].calling_dn = PAPI.Event.u.e.Calling_dn;
      callInfo[callIdx].called_dn = PAPI.Event.u.e.Called_dn;
      callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
      callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;
    }
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_SERVICE_INITIATED) {
    /* 수화기를 들었을 때 */
    let callIdx = findCallID(PAPI.Event.u.e.CallID);
    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
    }

    callInfo[callIdx].evt = PAPI.Event.event;
    callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
    callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;
    logReport.write(`[AGT-STATE] - 수화기를 들었을 때:${PAPI.Event.event}`);
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_ORIGINATED) {
    let callIdx = findCallID(PAPI.Event.u.e.CallID);
    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
    }

    callInfo[callIdx].evt = PAPI.Event.event;
    callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
    callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;
    logReport.write(`[CALL-PROCESS] - 호발생:${PAPI.Event.event}`);
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_DELIVERED) {
    /* 수신,발신 */
    let callIdx = findCallID(PAPI.Event.u.e.CallID);

    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
    }

    callInfo[callIdx].evt = ndProtocol.ND_EVT_DELIVERED;
    callInfo[callIdx].calling_dn = PAPI.Event.u.e.Calling_dn;
    callInfo[callIdx].called_dn = PAPI.Event.u.e.Called_dn;
    callInfo[callIdx].userInfo = PAPI.Event.u.e.UserInfo;
    callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
    callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;

    if (callIdx === 0) {
      logReport.write('[EVENT-BUS]EMIT - CONNECTION:originated');
      eventBus.$emit('call-connection', 'originated');
      if (store.getters.telNumber === PAPI.Event.u.e.Called_dn) {
        // IB
        logReport.write(`[EVENT-BUS]EMIT - INBOUND:${Helpers.stringifyData(PAPI.Event.u.e)}`);
        eventBus.$emit('call-bound:in', PAPI.Event.u.e);
        if (!Helpers.isStringValid(PAPI.Event.u.e.Redirection_dn)) {
          store.commit('changeCallUserKey', PAPI.Event.u.e.Calling_dn);
          eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_INCOMMING);
        }
      } else {
        // OB
        store.commit('changeCallUserKey', Helpers.inCommingPhoneCovert(PAPI.Event.u.e.Called_dn));
        logReport.write(`[EVENT-BUS]EMIT - OUTBOUND:${Helpers.stringifyData(PAPI.Event.u.e)}`);
        eventBus.$emit('call-bound:out', PAPI.Event.u.e);
        eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_OUTGOING);
      }
    }
    logReport.write(`[CALL-PROCESS] - 수신,발신:${PAPI.Event.event}`);
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_ESTABLISHED) {
    /* 통화 연결 */
    let callIdx = findCallID(PAPI.Event.u.e.CallID);

    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
    }

    callInfo[callIdx].evt = ndProtocol.ND_EVT_ESTABLISHED;
    callInfo[callIdx].calling_dn = PAPI.Event.u.e.Calling_dn;
    callInfo[callIdx].called_dn = PAPI.Event.u.e.Called_dn;
    callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
    callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;

    if (callIdx === 0) {
      store.commit('changeStartTime', new Date().getTime());
      if (PAPI.Event.u.e.Called_dn !== PAPI.Event.u.e.This_dn) {
        eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_ACTIVE);
      }
    }
    logReport.write(`[CALL-PROCESS] - 통화연결:${PAPI.Event.event}`);
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_HELD) {
    /* 보류 */
    let callIdx = findCallID(PAPI.Event.u.e.CallID);

    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
    }

    callInfo[callIdx].evt = ndProtocol.ND_EVT_HELD;
    callInfo[callIdx].holdingdn = PAPI.Event.u.e.Subject_dn;
    callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
    callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;
    logReport.write(`[ND_EVT_HELD] - 보류:${PAPI.Event.event}`);
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_RETRIEVED) {
    /* 재통화 */
    let callIdx = findCallID(PAPI.Event.u.e.CallID);

    if (callIdx < 0) {
      callIdx = findCallID(0);
      callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
    }

    callInfo[callIdx].evt = ndProtocol.ND_EVT_ESTABLISHED;
    callInfo[callIdx].localconnstate = PAPI.Event.u.e.localConnState;
    callInfo[callIdx].eventcause = PAPI.Event.u.e.eventCause;
    logReport.write(`[ND_EVT_RETRIEVED] - 재통화:${PAPI.Event.event}`);
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_CONFERENCED) {
    /* 3자통화 */
    if (store.getters.telNumber === PAPI.Event.u.e.Calling_dn) {
      eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_CONFERENCED_CALL_OUT);
      let callIdx = findCallID(PAPI.Event.u.e.secOldCallID);
      if (callIdx !== -1) {
        oneInitCallID(callIdx);
      }

      callIdx = findCallID(PAPI.Event.u.e.priOldCallID);
      if (callIdx !== -1) {
        callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
        callInfo[callIdx].evt = ndProtocol.ND_EVT_CONFERENCED;
      }
      logReport.write(`[CALL-PROCESS] - 3자통화:${PAPI.Event.event}`);
    } else if (store.getters.telNumber === PAPI.Event.u.e.Called_dn) {
      eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_CONFERENCED_CALL_IN);
      let callIdx = findCallID(PAPI.Event.u.e.secOldCallID);
      if (callIdx !== -1) {
        callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
        callInfo[callIdx].evt = ndProtocol.ND_EVT_CONFERENCED;
      }
    } else {
      let callIdx = findCallID(PAPI.Event.u.e.priOldCallID);
      if (callIdx !== -1) {
        /* ub
         oneInitCallID(callIdx);
          */
      }

      callIdx = findCallID(PAPI.Event.u.e.secOldCallID);
      if (callIdx !== -1) {
        callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
        callInfo[callIdx].evt = ndProtocol.ND_EVT_CONFERENCED;
      }
    }
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_TRANSFERRED) {
    /* 전환 */
    if (store.getters.telNumber === PAPI.Event.u.e.Calling_dn) {
      logReport.write('[EVENT-BUS]EMIT - CONNECTION:cleared');
      eventBus.$emit('call-connection', 'cleared');
      eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_TAKE_OVER_OUT);
      /* ub
       var callIdx = findCallID( PAPI.Event.u.e.priOldCallID );
       if(callIdx !== -1) {
         oneInitCallID(callIdx);
       }

       callIdx = findCallID( PAPI.Event.u.e.secOldCallID );
       if(callIdx !== -1) {
         oneInitCallID(callIdx);
       }
        */

      /* Neomecca */
      initCallID();
    } else if (store.getters.telNumber === PAPI.Event.u.e.Called_dn) {
      // 전화를 받은 경우
      eventBus.$emit('call-send-ticket-event', ticketEvent.CG_CALL_APP_TAKE_OVER_IN);
      let callIdx = findCallID(PAPI.Event.u.e.secOldCallID);
      if (callIdx !== -1) {
        callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
      }
    } else {
      let callIdx = findCallID(PAPI.Event.u.e.priOldCallID);
      if (callIdx !== -1) {
        callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
        callInfo[callIdx].evt = ndProtocol.ND_EVT_ESTABLISHED;
      }
    }
  } else if (PAPI.Event.event === ndProtocol.ND_EVT_CONNECTION_CLEARED) {
    /* 통화종료 */
    let callIdx = findCallID(PAPI.Event.u.e.CallID);

    if (callIdx < 0) {
      /* ub
       callIdx = findCallID(0);
       callInfo[callIdx].callId = PAPI.Event.u.e.CallID;
        */
    }

    if (callIdx !== -1) {
      /* 회의중 다른 사람이 끊었을 때 */
      if (store.getters.telNumber !== PAPI.Event.u.e.Subject_dn) {
        if (callInfo[callIdx].evt === ndProtocol.ND_EVT_CONFERENCED) {
          callInfo[callIdx].evt = ndProtocol.ND_EVT_ESTABLISHED;
        }
      } else if (store.getters.telNumber === PAPI.Event.u.e.Subject_dn) {
        if (callIdx === 0) {
          logReport.write('[EVENT-BUS]EMIT - CONNECTION:cleared');
          eventBus.$emit('call-connection', 'cleared');
          eventBus.$emit(
            'call-send-ticket-event',
            store.getters.callInfo.isAgentClose ? ticketEvent.CG_CALL_APP_CLOSE_AGENT : ticketEvent.CG_CALL_APP_CLOSE_CUSTOMER
          );
        }
        oneInitCallID(callIdx);
      }
    }
    store.dispatch('logInWebPhone');
    logReport.write(`[CALL-PROCESS]통화종료 - ${PAPI.Event.event}`);
  }

  /* Button */
  /* LogIn */
  if (PAPI.Event.event === ndProtocol.ND_EVT_MESSAGE || PAPI.Event.event === ndProtocol.ND_PRI_GROUP_AGENTLIST) {
    return;
  }

  if (isLogin === 1) {
    // 로컬 스토리지에 저장
    apiEvent.setLocalStorage(callInfo);

    switch (getCallCount()) {
      // Call Count 0
      case 0:
        switch (agtState) {
          case 0:
            apiEvent.buttonState(callDefs.STATE_LOGIN);
            break;
          case 1 /* 로그아웃 AG_NULL */:
            isLogin = 0;
            agtState = 0;
            apiEvent.buttonState(callDefs.STATE_LOGOUT);
            break;
          case 2 /* 대기 AG_READY */:
            apiEvent.buttonState(callDefs.STATE_READY);
            break;
          case 3 /* 후처리 AG_WORK_NOT_READY */:
            apiEvent.buttonState(callDefs.STATE_LOGIN);
            break;
          default:
            apiEvent.buttonState(callDefs.STATE_READY);
            break;
        }
        break;

      // Call Count 1
      case 1:
        let callIdx = findActiveCall();

        if (callIdx < 0) {
          console.log('FindActive Call error');
        } else {
          switch (callInfo[callIdx].evt) {
            case ndProtocol.ND_EVT_SERVICE_INITIATED:
              apiEvent.buttonState(callDefs.STATE_SERVICE_INITIATED);
              break;
            case ndProtocol.ND_EVT_ORIGINATED:
              apiEvent.buttonState(callDefs.STATE_ORIGINATED_COUNT1);
              break;
            case ndProtocol.ND_EVT_DELIVERED:
              if (Helpers.isStringValid(PAPI.Event.u.e.Subject_dn)) {
                if (store.getters.telNumber === PAPI.Event.u.e.Subject_dn) {
                  // Inbound
                  apiEvent.buttonState(callDefs.STATE_DELIVERED_RECV);
                } else {
                  // Outbound
                  apiEvent.buttonState(callDefs.STATE_DELIVERED_SEND);
                }
              }
              break;
            case ndProtocol.ND_EVT_ESTABLISHED:
              apiEvent.buttonState(callDefs.STATE_ESTABLISHED);
              break;
            case ndProtocol.ND_EVT_HELD:
              apiEvent.buttonState(callDefs.STATE_HOLD);
              break;
            case ndProtocol.ND_EVT_CONFERENCED:
              apiEvent.buttonState(callDefs.STATE_CONFERENCED);
              break;
          }
        }
        break;

      // Call Count 2
      case 2:
        let callIdx2 = findNotHeld(); // callIdx

        if (callIdx2 < 0) {
          console.log('FindNotHeld Call error');
        } else {
          switch (callInfo[callIdx2].evt) {
            case ndProtocol.ND_EVT_SERVICE_INITIATED:
              apiEvent.buttonState(callDefs.STATE_SERVICE_INITIATED);
              break;
            case ndProtocol.ND_EVT_ORIGINATED:
              apiEvent.buttonState(callDefs.STATE_ORIGINATED_COUNT2);
              break;
            case ndProtocol.ND_EVT_DELIVERED:
              apiEvent.buttonState(callDefs.STATE_DELIVERED_CONSULT);
              break;
            case ndProtocol.ND_EVT_ESTABLISHED:
              setTimeout(() => {
                apiEvent.buttonState(callDefs.STATE_ESTABLISHED_CONSULT);
              }, 100);
              break;
          }
        }
        break;
    }
  } else {
    /* LogOut */
    if (agtState === 1) {
      isLogin = 0;
      agtState = 0;
      apiEvent.buttonState(callDefs.STATE_LOGOUT);
    }
  }
}

/*****************************************************************************/
/* FUNCTON NAME : EvtDeliveredUEI()                                          */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtDeliveredUEI(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Redirection_dn = String.fromCharCode.apply(null, p.slice(308, 372)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(380, 384).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(384, 388).buffer)[0];

  var dLength = new Uint16Array(p.slice(392, 394).buffer)[0];
  if (dLength > ndCommon.UUI_SIZE || dLength < 0) {
    pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(394, 394 + ndCommon.UUI_SIZE + 1)).replaceAll(emptyCode, '');
  } else {
    pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(394, 394 + ndCommon.UUI_SIZE + 1)).replaceAll(emptyCode, '');
  }

  // pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(394, 651)).replaceAll(emptyCode,'');

  pEvent.Event.u.e.pData = String.fromCharCode.apply(null, p.slice(651, 691)).replaceAll(emptyCode, '');

  pEvent.Event.u.e.ShelfNo = String.fromCharCode.apply(null, p.slice(691, 696)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.ChannelNo = String.fromCharCode.apply(null, p.slice(696, 701)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.IPAddr = String.fromCharCode.apply(null, p.slice(701, 717)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.CustData = String.fromCharCode.apply(null, p.slice(717, 1230)).replaceAll(emptyCode, '');

  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtEstablished()                                           */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtEstablished(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Redirection_dn = String.fromCharCode.apply(null, p.slice(308, 372)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(380, 384).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(384, 388).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_ESTABLISHED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtCallCleared()                                           */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtCallCleared(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(92, 96).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(96, 100).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_CALL_CLEARED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtConnectionCleared()                                     */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtConnectionCleared(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(164, 168).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(168, 172).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_CONNECTION_CLEARED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtHeld()                                                  */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtHeld(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(164, 168).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(168, 172).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_HELD[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtRetrieved()                                             */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtRetrieved(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(164, 168).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(168, 172).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"",ND_EVT_RETRIEVED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtTransferred()                                           */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtTransferred(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(324, 328).buffer)[0];
  pEvent.Event.u.e.priOldCallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.secOldCallID = new Uint32Array(p.slice(92, 96).buffer)[0];
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Connection_dn1 = new Uint32Array(p.slice(328, 392).buffer)[0];
  pEvent.Event.u.e.Connection_dn2 = new Uint32Array(p.slice(400, 464).buffer)[0];
  pEvent.Event.u.e.Connection_dn3 = new Uint32Array(p.slice(472, 536).buffer)[0];
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(316, 320).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(320, 324).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_TRANSFERRED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtConferenced()                                           */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtConferenced(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(324, 328).buffer)[0];
  pEvent.Event.u.e.priOldCallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.secOldCallID = new Uint32Array(p.slice(92, 96).buffer)[0];
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Connection_dn1 = new Uint32Array(p.slice(328, 392).buffer)[0];
  pEvent.Event.u.e.Connection_dn2 = new Uint32Array(p.slice(400, 464).buffer)[0];
  pEvent.Event.u.e.Connection_dn3 = new Uint32Array(p.slice(472, 536).buffer)[0];
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(316, 320).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(320, 324).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_CONFERENCED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtConferencedIVR()                                        */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtConferencedIVR(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(324, 328).buffer)[0];
  pEvent.Event.u.e.priOldCallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.secOldCallID = new Uint32Array(p.slice(92, 96).buffer)[0];
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Connection_dn1 = new Uint32Array(p.slice(328, 392).buffer)[0];
  pEvent.Event.u.e.Connection_dn2 = new Uint32Array(p.slice(400, 464).buffer)[0];
  pEvent.Event.u.e.Connection_dn3 = new Uint32Array(p.slice(472, 536).buffer)[0];
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(316, 320).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(320, 324).buffer)[0];

  pEvent.Event.u.e.ShelfNo = String.fromCharCode.apply(null, p.slice(324, 329)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.ChannelNo = String.fromCharCode.apply(null, p.slice(329, 334)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.IPAddr = String.fromCharCode.apply(null, p.slice(334, 350)).replaceAll(emptyCode, '');

  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueued()                                                */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueued(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Redirection_dn = String.fromCharCode.apply(null, p.slice(308, 372)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.numberQueued = new Uint32Array(p.slice(380, 384).buffer)[0];
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(384, 388).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(388, 392).buffer)[0];

  var dLength = new Uint16Array(p.slice(396, 398).buffer)[0];
  if (dLength > ndCommon.UUI_SIZE || dLength < 0) {
    pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(398, 398 + ndCommon.UUI_SIZE + 1)).replaceAll(emptyCode, '');
  } else {
    pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(398, 398 + ndCommon.UUI_SIZE + 1)).replaceAll(emptyCode, '');
  }

  // pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(398, 655)).replaceAll(emptyCode,'');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_QUEUED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtDiverted()                                              */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtDiverted(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(236, 240).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(240, 244).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"",ND_EVT_DIVERTED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtNetworkReached()                                        */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtNetworkReached(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(236, 240).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(240, 244).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_NETWORK_REACHED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtCallInformation()                                       */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtCallInformation(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.AccountInfo = String.fromCharCode.apply(null, p.slice(164, 196)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.AuthCode = String.fromCharCode.apply(null, p.slice(196, 228)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"",ND_EVT_CALL_INFORMATION[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtBackInService()                                         */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtBackInService(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(84, 88).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_BACK_IN_SERVICE[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtOutOfService()                                          */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtOutOfService(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(84, 88).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_OUT_OF_SERVICE[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtFailed()                                                */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtFailed(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(164, 196)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(196, 200).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(200, 204).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_FAILED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtScreenPop()                                             */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtScreenPop(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(20, 60)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_SCREENPOP[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtChatDisconnect()                                        */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtChatDisconnect(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_CHTDISCONNECT[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtUniversalFailure()                                   */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtUniversalFailure(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(20, 24).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_UNIVERSAL_FAILURE[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtMessage()                                               */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtMessage(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.m.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.m.msgCode = new Uint32Array(p.slice(20, 24).buffer)[0];
  if (Event === 453) {
    pEvent.Event.u.m.Message = String.fromCharCode.apply(null, p.slice(24)).replaceAll(emptyCode, '');
  } else {
    pEvent.Event.u.m.Message = String.fromCharCode.apply(null, p.slice(24, 432)).replaceAll(emptyCode, '');
  }
  pEvent.Event.u.e.This_dn = pEvent.Event.u.m.This_dn;

  if (Event === 408 || Event === 453) {
    // var state = String.fromCharCode.apply(null, p.slice(48, 54)).replaceAll(emptyCode, '')
    // console.log(state)
    // pEvent.Event.u.m.Message = decodeURI(pEvent.Event.u.m.Message)
    pEvent.Event.u.m.Message = apiFunction.w2apiDecodeURIforEUCKR(escape(pEvent.Event.u.m.Message));
    // pEvent.Event.u.m.Message = apiFunction.decodeURIforEUCKR(escape(pEvent.Event.u.m.Message))
  }

  // // 대기고객
  // if (pEvent.Event.u.m.msgCode === 426) {
  //   var waitCustCnt, selfInCall, selfOutCall, selfCBCount
  //   waitCustCnt = pEvent.Event.u.m.Message.substr(55, 5)
  //   selfInCall = pEvent.Event.u.m.Message.substr(35, 5)
  //   selfOutCall = pEvent.Event.u.m.Message.substr(50, 5)
  //   selfCBCount = pEvent.Event.u.m.Message.substr(60, 5)
  //   pEvent.Event.u.m.Message = '000290500' + waitCustCnt + selfInCall + selfOutCall + selfCBCount
  //   // console.log(pEvent.Event.u.m.Message)
  // }

  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : CmdMakePredictiveCall()                                    */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function CmdMakePredictiveCall(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.FWD_dn = String.fromCharCode.apply(null, p.slice(20, 40)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(40, 60)).replaceAll(emptyCode, '');

  pEvent.Event.u.e.pData =
    apiFunction.fnLPad(new Uint32Array(p.slice(60, 64).buffer)[0], 4, '0') + apiFunction.fnLPad(new Uint32Array(p.slice(64, 68).buffer)[0], 2, '0');

  pEvent.Event.u.e.UserInfo = String.fromCharCode.apply(null, p.slice(74, 331)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_CMD_MAKE_PREDICTIVE_CALL[%s] [%s]",p->dn, pEvent.Event.u.e.UserInfo);return pEvent
  return pEvent;
}

function getCallCount() {
  var callCount = 0;

  for (var i = 0; i < 2; i++) {
    if (callInfo[i].callId !== 0) {
      callCount++;
    }
  }
  return callCount;
}

function findCallID(callId) {
  for (var i = 0; i < 2; i++) {
    if (callInfo[i].callId === callId) {
      return i;
    }
  }
  return -1;
}

function findCallEvt(evt) {
  for (var i = 0; i < 2; i++) {
    if (callInfo[i].evt === evt) {
      return i;
    }
  }
  return -1;
}

function findActiveCall() {
  for (var i = 0; i < 2; i++) {
    if (callInfo[i].callId !== 0) {
      return i;
    }
  }
  return -1;
}

function findNotHeld() {
  for (var i = 0; i < 2; i++) {
    if (callInfo[i].evt !== ndProtocol.ND_EVT_HELD) {
      return i;
    }
  }
  return -1;
}

function initCallID() {
  for (var i = 0; i < 2; i++) {
    callInfo[i].callId = 0;
    callInfo[i].evt = 0;
    callInfo[i].called_dn = '';
    callInfo[i].called_dn = '';
    callInfo[i].redirection_dn = '';
    callInfo[i].userInfo = '';
    callInfo[i].holdingdn = '';
    callInfo[i].localconnstate = 0;
    callInfo[i].eventcause = 0;
  }
}

function oneInitCallID(i) {
  callInfo[i].callId = 0;
  callInfo[i].evt = 0;
  callInfo[i].called_dn = '';
  callInfo[i].called_dn = '';
  callInfo[i].redirection_dn = '';
  callInfo[i].userInfo = '';
  callInfo[i].holdingdn = '';
  callInfo[i].localconnstate = 0;
  callInfo[i].eventcause = 0;
}

function setCallInfo(newVal) {
  callInfo = Object.assign({}, newVal);
}

function getCallInfo() {
  return callInfo;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtLoggedOn()                                              */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : void                                                       */

/*****************************************************************************/
function EvtLoggedOn(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.AgentID = String.fromCharCode.apply(null, p.slice(92, 124)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.AgentGroup = String.fromCharCode.apply(null, p.slice(124, 188)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_LOGGED_ON[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtLoggedOff()                                             */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : void                                                       */

/*****************************************************************************/
function EvtLoggedOff(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.AgentID = String.fromCharCode.apply(null, p.slice(92, 124)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_LOGGED_OFF[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtMonitorConf()                                           */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtMonitorConf(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  // NDWriteLog(LEVEL5,gLogLevel,"",ND_EVT_MONITOR_DEVICE[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtChangeMonitorConf()                                     */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtChangeMonitorConf(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_CHG_MONITOR[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtMonitorEnded()                                          */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtMonitorEnded(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_MONITOR_ENDED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtMessageWaiting()                                        */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtMessageWaiting(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.MSGFlag = new Uint32Array(p.slice(164, 168).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_MESSAGE_WAITING[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtDoNotDisturb()                                          */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtDoNotDisturb(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.DNDFlag = new Uint32Array(p.slice(92, 96).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_DO_NOT_DISTURB[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtForwarding()                                            */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtForwarding(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.FWDType = new Uint32Array(p.slice(92, 96).buffer)[0];
  pEvent.Event.u.e.FWDFlag = new Uint32Array(p.slice(96, 100).buffer)[0];
  pEvent.Event.u.e.FWD_dn = String.fromCharCode.apply(null, p.slice(100, 164)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_FORWARDING[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueryMWI()                                              */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueryMWI(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.MSGFlag = new Uint32Array(p.slice(20, 24).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_QUERY_MWI[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueryDND()                                              */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueryDND(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.DNDFlag = new Uint32Array(p.slice(20, 24).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_QUERY_DND[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueryFWD()                                              */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueryFWD(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;

  if (new Uint32Array(p.slice(20, 24).buffer)[0] > 0) {
    for (var i = 0; i < 7; i++) {
      if (pEvent.Event.u.e.FWDFlag === new Uint32Array(p.slice(i * 72 + 28, i * 72 + 32).buffer)[0]) {
        pEvent.Event.u.e.FWDType = new Uint32Array(p.slice(i * 72 + 24, i * 72 + 28).buffer)[0];
        pEvent.Event.u.e.FWDFlag = new Uint32Array(p.slice(i * 72 + 28, i * 72 + 32).buffer)[0];
        pEvent.Event.u.e.FWD_dn = String.fromCharCode.apply(null, p.slice(i * 72 + 32, i * 72 + 96)).replaceAll(emptyCode, '');
        break;
      }
    }
  } else {
    pEvent.Event.u.e.FWDType = new Uint32Array(p.slice(24, 28).buffer)[0];
    pEvent.Event.u.e.FWDFlag = new Uint32Array(p.slice(28, 32).buffer)[0];
    pEvent.Event.u.e.FWD_dn = String.fromCharCode.apply(null, p.slice(32, 96)).replaceAll(emptyCode, '');
  }
  // NDWriteLog(LEVEL5,gLogLevel,"",ND_EVT_QUERY_FWD[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueryAgentState()                                       */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueryAgentState(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.AGTstate = new Uint32Array(p.slice(20, 24).buffer)[0];
  ndCommon.IS_CHANGE_STATUS = false;
  // 후처리
  if (pEvent.Event.u.e.AGTstate === 3) {
    eventBus.$emit('call-work-not-ready');
  }
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_QUERY_AGENT_STATE[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueryLastNumber()                                       */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueryLastNumber(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_QUERY_LAST_NUMBER[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtQueryDeviceInfo()                                       */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtQueryDeviceInfo(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(20, 84)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.DEVType = new Uint32Array(p.slice(84, 88).buffer)[0];
  pEvent.Event.u.e.DEVClass = String.fromCharCode.apply(null, p.slice(88, 92)).replaceAll(emptyCode, '');
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_QUERY_DEVICE_INFO[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtServiceInitiated()                                      */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtServiceInitiated(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(92, 96).buffer)[0];
  // pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(96, 98).buffer)[0]
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_SERVICE_INITIATED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtOriginated()                                            */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtOriginated(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(216, 220).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(220, 224).buffer)[0];
  // NDWriteLog(LEVEL5,gLogLevel,"","ND_EVT_ORIGINATED[%s]",p->dn);
  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME : EvtDelivered()                                             */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : function                                                   */

/*****************************************************************************/
function EvtDelivered(p, Event) {
  var pEvent = new ndCommon.P_API();
  pEvent.Event.u.e.This_dn = String.fromCharCode.apply(null, p.slice(0, 20)).replaceAll(emptyCode, '');
  pEvent.Event.event = Event;
  pEvent.Event.u.e.CallID = new Uint32Array(p.slice(20, 24).buffer)[0];
  pEvent.Event.u.e.Subject_dn = String.fromCharCode.apply(null, p.slice(92, 156)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Calling_dn = String.fromCharCode.apply(null, p.slice(164, 228)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Called_dn = String.fromCharCode.apply(null, p.slice(236, 300)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.Redirection_dn = String.fromCharCode.apply(null, p.slice(308, 372)).replaceAll(emptyCode, '');
  pEvent.Event.u.e.localConnState = new Uint32Array(p.slice(380, 384).buffer)[0];
  pEvent.Event.u.e.eventCause = new Uint32Array(p.slice(384, 388).buffer)[0];

  if (pEvent.Event.u.e.Redirection_dn) {
    // 이관일 때
    pEvent.Event.u.e.UserInfo = String.fromCharCode
      .apply(null, p.slice(394, 394 + ndCommon.UUI_SIZE + 1))
      .replaceAll(emptyCode, '')
      .trim();
  } else if (store.getters.telNumber === pEvent.Event.u.e.Called_dn) {
    // INBOUND
    const userInfo = String.fromCharCode.apply(null, p.slice(394, 394 + ndCommon.UUI_SIZE + 1)).replaceAll(emptyCode, '');
    pEvent.Event.u.e.UserInfo = {
      dnis: userInfo.substr(60, 11).trim(),
      serviceCode: userInfo.substr(56, 4),
      ticketId: userInfo.substr(191, 20)
    };
  } else {
    // OUTBOUND
    pEvent.Event.u.e.UserInfo = String.fromCharCode
      .apply(null, p.slice(394, 394 + ndCommon.UUI_SIZE + 1))
      .replaceAll(emptyCode, '')
      .slice(60, 71)
      .trim();
  }

  pEvent.Event.u.e.pData = String.fromCharCode
    .apply(null, p.slice(394 + ndCommon.UUI_SIZE + 1, 394 + ndCommon.UUI_SIZE + 1 + 40))
    .replaceAll(emptyCode, '');

  return pEvent;
}

/*****************************************************************************/
/* FUNCTON NAME :FindDN()                                                   */
/* DESCRIPTION  :                                                            */
/* INPUT        :                                                            */
/* OUTPUT       : void                                                       */

/*****************************************************************************/
function FindDN(DN) {
  var pDN = 0;

  for (pDN = gpDNHead; pDN !== 0; pDN = pDN.next) {
    if (pDN.dn !== DN) {
      continue;
    }

    return pDN;
  }
  return 0;
}

function initIsLogin() {
  isLogin = 0;
}



// WEBPACK FOOTER //
// ./src/util/call/neoWebRTC/neoWebRtcAPI/neoWebRtcAPI.js